import React, { useState, useEffect } from 'react';

interface ContadorItemsProps {
  cantidad: number;
  setCantidadItem: (cantidad: number) => void;
  deshabilitado: boolean;
  cantidadMaxima: number;
}

const ContadorItems: React.FC<ContadorItemsProps> = ({cantidad, setCantidadItem, deshabilitado, cantidadMaxima}) => {

 
  const increment = () => {
    if (cantidad === cantidadMaxima) return;
    setCantidadItem(cantidad + 1);
  };

  const decrement = () => {
    if (cantidad === 0) return;
    setCantidadItem(cantidad - 1);
  };    

  return (
    <div className="flex flex-row items-center justify-center border-2 border-vp-azul rounded-lg h-[30px] overflow-hidden" >
      <button className="w-[30px] h-[30px] text-center hover:bg-vp-azulclaro hover:border-vp-azulclaro hover:text-white disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-black" onClick={increment} disabled={(deshabilitado || cantidad === cantidadMaxima)}>+</button>
      <input type="text" value={cantidad} readOnly className="border-2 border-vp-azul w-[30px] h-[30px] text-center cursor-default disabled:cursor-not-allowed" disabled={true}/>
      <button className="w-[30px] h-[30px] text-center hover:bg-vp-azulclaro hover:border-vp-azulclaro hover:text-white disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-black" onClick={decrement} disabled={(deshabilitado || cantidad === 0)}>-</button>
    </div>
  );
};

export default ContadorItems;